export default __webpack_public_path__ + "static/media/flow1_cleaning_mobile.feac01ed.svg";